// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"VaV90","effectsGrayscale30":"_1LvR8","resetList":"_1lydS","wrapper":"e5E3x","buttons":"_3wBrv"};